import { Link } from "react-router-dom";

export default function FeaturedProducts() {
  const products = [
    {
      image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_padel-shop-4/artifacts/nldlxshe_espresso-front.png",
      name: "Performance Tee — Espresso",
      id: "perf-tee-espresso",
    },
    {
      image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_padel-shop-4/artifacts/whbinv1q_white-front.png",
      name: "Performance Set — White",
      id: "perf-tee-white",
    },
  ];

  return (
    <section
      data-testid="featured-products"
      className="py-20 sm:py-28 lg:py-36 bg-[#FDFDFD]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-14 sm:mb-20">
          <div>
            <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#8B6F47] mb-3" style={{ fontStyle: "normal" }}>
              Oktober Drop
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-[#0A0A0A]">
              The New Collection
            </h2>
          </div>
          <Link
            to="/shop"
            data-testid="view-all-link"
            className="text-xs tracking-[0.15em] uppercase text-[#0A0A0A] border-b border-[#0A0A0A] pb-1 hover:opacity-60 transition-opacity hidden sm:block"
            style={{ fontStyle: "normal" }}
          >
            View All
          </Link>
        </div>

        {/* Product showcase — side by side */}
        <div className="grid grid-cols-12 gap-3 sm:gap-4">
          <div className="col-span-12 sm:col-span-6 overflow-hidden bg-[#F0EDE8]">
            <Link to={`/product/${products[0].id}`} className="block group">
              <img
                src={products[0].image}
                alt={products[0].name}
                className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </Link>
          </div>
          <div className="col-span-12 sm:col-span-6 overflow-hidden bg-[#F0EDE8]">
            <Link to={`/product/${products[1].id}`} className="block group">
              <img
                src={products[1].image}
                alt={products[1].name}
                className="w-full aspect-[3/4] object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </Link>
          </div>
        </div>

        <div className="mt-10 text-center sm:hidden">
          <Link
            to="/shop"
            className="inline-block bg-[#0A0A0A] text-white px-8 py-3 text-xs tracking-[0.2em] uppercase"
            style={{ fontStyle: "normal" }}
          >
            View All Products
          </Link>
        </div>
      </div>
    </section>
  );
}
